<template>
  <div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Name</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="player.username" class="input oc-input" type="text" />
          </p>
          <p class="help is-danger" v-if="!$v.player.username.required">Name is required</p>
          <p class="help is-danger" v-if="!$v.player.username.minLength || !$v.player.username.maxLength">Name length 3-50</p>
          <p class="help is-danger" v-if="!$v.player.username.isUnique">User with the same name already exists</p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Password</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="player.password" class="input oc-input" type="text" />
          </p>
          <p class="help is-danger" v-if="!$v.player.password.required">Password is required</p>
          <p class="help is-danger" v-if="!$v.player.password.minLength || !$v.player.password.maxLength">Password length 4-50</p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Phone</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="player.phoneNumber" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Email</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="player.email" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Language</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div class="select">
              <select v-model="player.language">
                <option v-for="lang in languages" :key="lang">{{lang}}</option>
              </select>
            </div>
          </div>
          <p class="help is-danger" v-if="!$v.player.language.required">Language is required</p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Registration type</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div v-if="registrationTypes && registrationTypes.length" class="select">
              <select v-model="player.registrationType">
                <option v-for="rt in registrationTypes" :key="rt" :value="rt">{{rt}}</option>
              </select>
            </div>
            <input v-else v-model="player.registrationType" class="input oc-input" type="text" />
          </div>
          <p class="help is-danger" v-if="!$v.player.registrationType.required">Registration type is required</p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Messenger</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div class="select">
              <select v-model="player.messenger">
                <option>vb</option>
                <option>wa</option>
                <option>tg</option>
                <option>sms</option>
                <option>email</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button class="button is-primary" @click="create()" :disabled="$v.$invalid">Create</button>
      </div>
    </div>
  </div>
</template>
<script>
  import state from '../../../../../state'
  import playerService from '../../../../../services/player.service'
  import { required, minLength, maxLength } from 'vuelidate/lib/validators'

  export default {
    name: 'player-create',
    data() {
      return {
        player: {
          username: '',
          phoneNumber: '',
          email: '',
          password: '',
          language: null,
          registrationType: 'login'
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      },
      client() {
        return state.clients.getClient(this.clientId)
      },
      registrationTypes() {
        return this.client.settings.registrationSettings.registrationTypes;
      },
      languages() {
        return state.languages.get();
      }
    },
    validations: {
      player: {
        username: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(50),
          async isUnique(value) {
            return !value || (await playerService.checkUsername(value, this.clientId)).isValid;
          }
        },
        password: {
          required,
          minLength: minLength(4),
          maxLength: maxLength(50)
        },
        language: {
          required
        },
        registrationType: {
          required
        }
      }
    },
    methods: {
      async create() {
        this.player.clientId = this.clientId;
        await playerService.create(this.player);
        this.$router.push({ name:'players' });
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/player/create.vue